import React, { createContext, useState } from "react";
import { Alert, Button, Form } from "react-bootstrap";

import Navbar from "../components/Navbar";
import Dropzone from "../components/Dropzone";
import VideoForm from "../components/VideoForm";
import VideoFormReview from "../components/VideoFormReview";
import { FormValues } from "../utils/types";
import Modal from "../components/Modal";
import colors from "../utils/colors";
import "../components/style.css";

const initialContextValue = {
  fileName: "",
  setFileName: (state: string) => {},
  valuesForm: {
    camera: "",
    date: "",
    insight: "",
    keywords: "",
    suburb: "",
    name: "",
    orientation: "",
    postcode: "",
    provider: "",
    sensitivity: "",
    street: "",
    submit: false,
    videoURL: "",
    location: "",
  },
  setValuesForm: (state: FormValues) => {},
  setShowReview: (state: boolean) => {},
  setUploadImage: (state: FileList) => {},
  setSubmitStatus: (state: submitStatusType) => {},
  setIsModalOpen: (state: boolean) => {},
};
const initialValues = {
  camera: "",
  date: "",
  insight: "",
  keywords: "",
  suburb: "",
  name: "",
  orientation: "",
  postcode: "",
  provider: "",
  sensitivity: "",
  street: "",
  submit: false,
  videoURL: "",
  location: "",
};
interface UploadPropsType {
  setUrl: (state: string) => void;
}
interface submitStatusType {
  status: string;
  text: string;
}
export const FileNameContext = createContext(initialContextValue);

export default function Upload(props: UploadPropsType) {
  const { setUrl } = props;
  const [fileName, setFileName] = useState("");
  const [showReview, setShowReview] = useState(false);
  const [valuesForm, setValuesForm] = useState<FormValues>(initialValues);
  const [uploadImage, setUploadImage] = useState<FileList>();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<submitStatusType>({
    status: "",
    text: "",
  });

  console.log("valuesForm", valuesForm);
  return (
    <div style={{ background: colors.SLSsecondary, paddingBottom: "50px" }}>
      <FileNameContext.Provider
        value={{
          fileName,
          setFileName,
          valuesForm,
          setValuesForm,
          setShowReview,
          setUploadImage,
          setSubmitStatus,
          setIsModalOpen,
        }}
      >
        <Navbar />
        {/* <button
          onClick={() => {
            setIsModalOpen(true);
          }}
        >
          Open
        </button> */}
        <Modal isModalOpen={isModalOpen}>
          <p style={{ fontSize: "22px" }}>{submitStatus.text}</p>
        </Modal>
        <div className="upload_body">
          <div style={{ padding: "0 30px" }}>
            <Alert
              className="my-3 text-center"
              variant="primary"
              style={{ fontSize: "18px" }}
            >
              <div className="alert-message">
                <strong>Step 1 : </strong>
                Choose a video and Upload
              </div>
            </Alert>
          </div>
          <div className="upload_section" style={{ padding: "0 30px" }}>
            <Dropzone />
          </div>
          {showReview ? (
            <VideoFormReview uploadImage={uploadImage} />
          ) : (
            <VideoForm uploadImage={uploadImage} setUrl={setUrl} />
          )}
        </div>
      </FileNameContext.Provider>
    </div>
  );
}
